/**
 * Календарные даты без времени (дата рождения, выдача документа и т.п.).
 * Храним и отправляем в API как YYYY-MM-DD, без UTC-сдвига суток.
 */

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * @param {number} year
 * @param {number} month — 1–12
 * @param {number} [day=1]
 * @returns {Date}
 */
export function createLocalDate(year, month, day = 1) {
  return new Date(year, month - 1, day);
}

/**
 * @param {Date|string|null|undefined} value
 * @returns {Date|null}
 */
export function parseDateOnly(value) {
  if (value == null || value === '') {
    return null;
  }

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return null;
    }
    return createLocalDate(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    const dateOnlyMatch = DATE_ONLY_RE.exec(trimmed);
    if (dateOnlyMatch) {
      const year = Number(dateOnlyMatch[1]);
      const month = Number(dateOnlyMatch[2]);
      const day = Number(dateOnlyMatch[3]);
      return createLocalDate(year, month, day);
    }

    // Legacy ISO datetime: берём локальный календарный день браузера
    // (для уже сохранённых минских полночей это сохраняет выбранный день).
    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) {
      return null;
    }
    return createLocalDate(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate());
  }

  return null;
}

/**
 * @param {Date|string|null|undefined} value
 * @returns {string|null} YYYY-MM-DD
 */
export function formatDateOnly(value) {
  const date = value instanceof Date && !Number.isNaN(value.getTime())
    ? value
    : parseDateOnly(value);

  if (!date) {
    return null;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
